"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var index=require("./spinner/index.js");require("react"),exports.Spinner=index.Spinner;
